var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHumidityIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 18,
    viewBox: "0 0 13 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.45005 17.2C2.89354 17.2 0 14.4748 0 11.1251C0 6.45 6.4501 0 6.4501 0C6.4501 0 12.9 6.45 12.9 11.1251C12.9 14.4748 10.0066 17.2 6.45005 17.2Z",
    fill: "#20E89C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.67519 10.75C9.19522 12.2518 7.98885 13.4526 6.4502 13.975",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHumidityIcon);
export default __webpack_public_path__ + "static/media/HumidityIcon.8ee947a52c50415ba18980f11c7e8e5b.svg";
export { ForwardRef as ReactComponent };